import { createSlice } from "@reduxjs/toolkit";

interface SessionState {
  expired: boolean;
  message: string;
  code: string;
}

const initialState: SessionState = {
  expired: false,
  message: "",
  code: "",
};

const sessionSlice = createSlice({
  name: "session",
  initialState,
  reducers: {
    setSessionExpired: (state, action) => {
      state.expired = true;
      state.message = action.payload.message;
      state.code = action.payload.code;
    },

    resetSessionExpired: (state) => {
      state.expired = false;
      state.message = "";
      state.code = "";
    },
  },
});

export const { setSessionExpired, resetSessionExpired } = sessionSlice.actions;

export default sessionSlice.reducer;
